const ENDPOINT = 'jschema';

export default axios => ({
  /**
   * Get JSCHMEAS list, list of all
   * @param params - params to path on backend
   * @return {*}
   */
  getList(params) {
    return axios.get(`/${ENDPOINT}/all`, {
      redirect: 'follow',
      params
    });
  },


  /**
   * Get Single Schema By Id
   * @param id - item id
   * @return {*}
   */
  getSingleByID(id, params) {
    return axios.get(`/${ENDPOINT}/${id}`, {
        redirect: 'follow',
        params,
    });
  },

  /**
   * Add new JSCHEMA.
   * @param data - JSON data to add
   * @param params - params to path on backend
   * @return {*}
   */
  add(data, params) {
    return axios.post(`/${ENDPOINT}/new`, {
        ...data,
      },
      {
        redirect: 'follow',
        params,
      }
    );
  },

  /**
   * Update JSCHEMA By ID
   * @param id - item id
   * @param data  - JSON data to update
   * @param params - params to path on backend
   */
  update(id, data, params) {
      return axios.put(`/${ENDPOINT}/${id}`, {
          ...data,
        },
        {
          redirect: 'follow',
          params,
        }
      );
  },

  /**
   * Delete JSCHEMA By ID
   * @param id - item id 
   */
  delete(id) {
      return axios.delete(`/${ENDPOINT}/${id}`, {
        redirect: 'follow',
      });
  }
});



// WEBPACK FOOTER //
// ./src/services/jschemas.service.js